import {
    DIC
} from '@/const/dic'
// import {
//     validateChinese
// } from '@/util/validate'
// import {
//     formatterTime
// } from '@/util/util'



export const arOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    printBtn: true,
    excelBtn: true,
    columnBtn: false,
    //viewBtn: true,
    menuWidth: '200',
    labelWidth: '150',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "账号",
            prop: "account",
            search: true,
            type: 'input'
        },
        {
            label: "店铺名称",
            prop: "shopName",
            type: "input",
            search: true,
            width: "110"
        },
        {
            label: "法人名称",
            prop: "name",
            width: "110",
            type: 'input',
            search: true,
        },
        {
            label: "店铺地址",
            prop: "shopAddress",
            type: "input",
            search: true
        },
        {
            label: "上次结算时间",
            prop: "lastPayTime",
            type: "datetime",
            // sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            formatter: function (row, value, label, column) {
                if (row.lastPayTime != 0) {
                    return row.lastPayTime
                }
            },
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "结算方式",
            prop: "clearingType",
            type: "select",
            search: true,
            dicData: DIC.FINANCIAL_STATUS
        },
        {
            label: "应收款笔数",
            prop: "allCount",
            // solt: true,
            type: 'input',
        },
        {
            label: "应收款总额",
            prop: "allPrice",
            // solt: true,
            type: 'input',
        },
        {
            label: "支付时间区间",
            prop: "payTimeInterval",
            type: "datetimerange",
            sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            // search: true,
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "采购时间",
            prop: "startDate_endDate",
            type: "datetimerange",
            valueFormat: "timestamp",
            span: 24,
            clearable: true,
            // search: true,
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false,
            formatter: function (row, value, label, column) {
                return formatterTime(row.startTime) + '至' + formatterTime(row.endTime)
            }
        }
    ]
};